{
	"back": "Back",
	"error": "Error",
	"loading": "Loading",
	"continue": "Continue",
	"to_do_this_we_will_ask_you_to": "To do this we will ask you to",
	"verify_your_mobile_number_bold": "<strong>Verify</strong> your mobile number",
	"verify_your_mobile_number": "Verify your mobile number",
	"consent_to_share_your_data_with_us": "<strong>Consent</strong> to share your data with us",
	"share_your_financial_data": "<strong>Share</strong> your financial data",
	"things_you_should_know": "Things you should know",
	"we_dont_share_your_data_without_your_consent": "We don’t share your data without your consent",
	"you_can_easily_stop_sharing_your_data_at_any_time": "You can easily stop sharing your data at any time",
	"you_can_choose_to_delete_shared_data_when_we_no_longer_need_it": "You can choose to delete shared data when we no longer need it",
	"by_proceeding_you_agree_to_the": "By proceeding, you agree to the",
	"terms_of_service": "Terms of service",
	"privacy_notice": "Privacy notice",
	"and": "and",
	"use_basiq_to_connect_your_accounts": "${name} use <strong>Basiq</strong> to connect your accounts",
	"we_use_basiq_to_connect_your_accounts": "We use <strong>Basiq</strong> to connect your accounts",
	"please_enter_the_sms_code_sent_to_your_mobile_number": "Please enter the SMS code sent to your mobile number (ending in xxx${number}).",
	"new_sms_code_has_been_sent": "New SMS code has been sent.",
	"this_code_doesnt_appear_to_be_valid": "This code doesn't appear to be valid.",
	"didnt_receive_the_code": "Didn’t receive the code?",
	"resend_sms": "Resend SMS",
	"failed_to_send_sms": "Failed to send SMS.",
	"page_not_found": "Page not found",
	"missing_authentication_token": "Missing Authentication Token",
	"too_many_attempts": "Too many attempts. Please use a new link to try again."
}
